import axios from 'axios'

export default {
  namespaced: true,
  state: {
    token: '',
    logoutToken: ''
  },
  getters: {
    isLogged: state => {
      return !!state.token
    }
  },
  actions: {
    check: ({ dispatch, state }) => {
      if (state.token) {
        // TODO: dispatch only on page load
        dispatch('setHeaders')
      }
    },
    async request({ dispatch, state }, code) {
      if (state.token) {
        await dispatch('logout')
      }

      return new Promise((resolve, reject) => {
        dispatch('login', code)
          .then(() => resolve())
          .catch(error => reject(error))
      })
    },
    login: ({ commit, dispatch }, code) => {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_API + '/user/login?_format=json',
            { name: code, pass: code },
            { withCredentials: true }
          )
          .then(response => {
            commit('success', {
              token: response.data.csrf_token,
              logoutToken: response.data.logout_token
            })
            dispatch('setHeaders')
            commit(
              'user/set',
              {
                id: response.data.current_user.uid,
                name: response.data.current_user.name
              },
              { root: true }
            )
            dispatch('user/load', null, { root: true })
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    logout: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_API +
              '/user/logout?_format=json&token=' +
              state.logoutToken
          )
          .then(() => {
            commit('clear')
            commit('user/clear', null, { root: true })
            dispatch('clearHeaders')
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setHeaders: ({ state }) => {
      axios.defaults.headers.common['X-CSRF-Token'] = state.token
      axios.defaults.withCredentials = true
    },
    clearHeaders: () => {
      delete axios.defaults.headers.common['X-CSRF-Token']
      delete axios.defaults.withCredentials
    }
  },
  mutations: {
    success: (state, { token, logoutToken }) => {
      state.token = token
      state.logoutToken = logoutToken
    },
    clear: state => {
      state.token = ''
      state.name = ''
    }
  }
}
